import { navigate } from "gatsby";
import { type ComponentType, useEffect } from "react";
import { useIsUserLoggedIn } from "../hooks/useIsUserLoggedIn";

export function withRedirectWhenLoggedIn<T extends {}>(PageComponent: ComponentType<T>): (props: T) => JSX.Element {
    return function withRedirectWhenLoggedInInner(props: T): JSX.Element {
        const isLoggedUser = useIsUserLoggedIn();
        useEffect(() => {
            isLoggedUser && navigate("/smlouvy/");
        }, [isLoggedUser]);
        return <PageComponent {...props} />;
    };
}

export default withRedirectWhenLoggedIn;
